export default __webpack_public_path__ + "static/shein_logo-a414b14dbb533785722dbc26b464383e.svg";